<template>
  <h3 class="mt-3">{{ $t("registmessage.title") }}</h3>
  <el-row justify="center" class="mt-3">
    <el-col :span="9">
      <h6 style="float: left; font-weight: bold">
        {{ $t("registmessage.header1") }}
      </h6>
    </el-col>
    <el-col :span="10"></el-col>
  </el-row>

  <el-row justify="center" class="mt-3">
    <el-col :span="18">
      <p style="float: left">
        {{ $t("registmessage.notice1") }}
      </p>
    </el-col>
  </el-row>
  <!-- name -->
  <el-row justify="center" class="mt-3">
    <el-col :span="9"
      ><p v-if="firstname != ''" class="utitle">
        {{ $t("registmessage.firstname") }}
      </p></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><p v-if="lastname != ''" class="utitle">
        {{ $t("registmessage.lastname") }}
      </p></el-col
    >
  </el-row>
  <el-row
    justify="center"
    :class="[firstname == '' && lastname == '' ? 'mt-3' : 'mt-0']"
  >
    <el-col :span="9"
      ><el-input
        v-model="firstname"
        :placeholder="$t('registmessage.firstname')"
        clearable
    /></el-col>
    <el-col :span="1"
      ><div class="mx-2" style="float: left; color: red">*</div></el-col
    >
    <el-col :span="8"
      ><el-input
        v-model="lastname"
        :placeholder="$t('registmessage.firstname')"
        clearable
    /></el-col>
    <el-col :span="1"
      ><div class="mx-2" style="float: left; color: red">*</div></el-col
    >
  </el-row>
  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="firstnameempty" class="sfont">Firstname empty</div></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><div class="sfont" v-if="lastnameempty">Lastname empty</div></el-col
    >
  </el-row>

  <!-- 用户名 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="myusername != ''" class="utitle">
        {{ $t("registmessage.username") }}
      </p></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <el-row
    justify="center"
    align="middle"
    :class="[myusername == '' ? 'mt-3' : 'mt-0']"
  >
    <el-col :span="9">
      <el-input
        id="tuiguangusername"
        v-model="myusername"
        :placeholder="$t('registmessage.username')"
        clearable
        @blur="oncheckusername"
      />
    </el-col>
    <el-col :span="1"
      ><div class="mx-2" style="float: left; color: red">*</div></el-col
    >
    <el-col :span="9">
      <i
        v-if="usernamestatus == 1"
        style="float: left; color: green"
        class="bi bi-check-lg"
      ></i>
      <i
        v-if="usernamestatus == 0"
        style="float: left; color: red"
        class="bi bi-x-lg"
      ></i>
      <div v-if="usernamestatus == 0">
        Username already taken. Suggested username:{{ advisedusername }}
      </div>
    </el-col>
  </el-row>

  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="usernameempty" class="sfont">Username empty</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <!-- 公司 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="company != ''" class="utitle">
        {{ $t("registmessage.company") }}
      </p></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <el-row
    justify="center"
    align="middle"
    :class="[company == '' ? 'mt-3' : 'mt-0']"
  >
    <el-col :span="9">
      <el-input
        id="tuiguangcompany"
        v-model="company"
        :placeholder="$t('registmessage.company')"
        clearable
      />
    </el-col>
    <el-col :span="1"
      ><div class="mx-2" style="float: left; color: red">*</div></el-col
    >

    <el-col :span="9"></el-col>
  </el-row>

  <!-- 密码 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="passwd != ''" class="utitle">
        {{ $t("registmessage.passwd") }}
      </p></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><p v-if="confirmpasswd != ''" class="utitle">
        {{ $t("registmessage.confirmpasswd") }}
      </p></el-col
    >
  </el-row>
  <el-row
    justify="center"
    :class="[passwd == '' && confirmpasswd == '' ? 'mt-3' : 'mt-0']"
  >
    <el-col :span="9"
      ><el-input
        v-model="passwd"
        type="password"
        :placeholder="$t('registmessage.passwd')"
        clearable
        @blur="oncheckpasswd"
    /></el-col>
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><el-input
        v-model="confirmpasswd"
        type="password"
        :placeholder="$t('registmessage.confirmpasswd')"
        clearable
        @blur="onconfirmpasswd"
    /></el-col>
  </el-row>
  <!-- 密码合法与一致性检验 -->
  <el-row justify="center" class="mt-0">
    <el-col :span="9"
      ><div v-if="!passwdvalidation" class="sfont">
        {{ passwderrmess }}
      </div></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><div v-if="!samepasswd" class="sfont">
        Password doesn't match
      </div></el-col
    >
  </el-row>

  <!-- 电子邮件 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="email != ''" class="utitle">
        {{ $t("registmessage.email") }}
      </p></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><p v-if="cemail != ''" class="utitle">
        {{ $t("registmessage.confirmemail") }}
      </p></el-col
    >
  </el-row>
  <el-row
    justify="center"
    :class="[email == '' && cemail == '' ? 'mt-3' : 'mt-0']"
  >
    <el-col :span="9"
      ><el-input
        @blur="ValidateEmail"
        v-model="email"
        type="email"
        :placeholder="$t('registmessage.email')"
        clearable
    /></el-col>
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><el-input
        v-model="cemail"
        type="cemail"
        :placeholder="$t('registmessage.confirmemail')"
        clearable
        @blur="onconfirmemail"
    /></el-col>
  </el-row>
  <!-- 邮件合法化检验 -->
  <el-row justify="center" class="mt-0">
    <el-col :span="9"
      ><div v-if="invalidemail" class="sfont">
        {{ $t("registmessage.emailcheck") }}
      </div></el-col
    >
    <el-col :span="1"></el-col>
    <el-col :span="9"
      ><div v-if="!sameemail" class="sfont">
        {{ $t("registmessage.emailmatch") }}
      </div></el-col
    >
  </el-row>

  <!-- 领域 research field -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="selecteddomain != ''" class="utitle">
        {{ $t("registmessage.selectdomain") }}
      </p></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" :class="[selecteddomain == '' ? 'mt-3' : 'mt-0']">
    <el-col :span="9">
      <el-select
        v-model="selecteddomain"
        :placeholder="$t('registmessage.selectdomain')"
        style="display: block"
      >
        <el-option
          v-for="item in domain"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="1"
      ><div class="mx-2 mt-2" style="float: left; color: red">*</div></el-col
    >
    <el-col :span="9"></el-col>
  </el-row>
  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="domainempty" class="sfont">Research Field Empty</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <!-- 学历水平 education -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="selectededucation != ''" class="utitle">
        {{ $t("registmessage.selecteducation") }}
      </p></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" :class="[selectededucation == '' ? 'mt-3' : 'mt-0']">
    <el-col :span="9">
      <el-select
        v-model="selectededucation"
        :placeholder="$t('registmessage.selecteducation')"
        style="display: block"
      >
        <el-option
          v-for="item in education"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="1"
      ><div class="mx-2 mt-2" style="float: left; color: red">*</div></el-col
    >
    <el-col :span="9"></el-col>
  </el-row>
  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="educationempty" class="sfont">Education empty</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <!-- 职业 Occupation -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="selectedoccupation != ''" class="utitle">
        {{ $t("registmessage.selectoccupation") }}
      </p></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" :class="[selectededucation == '' ? 'mt-3' : 'mt-0']">
    <el-col :span="9">
      <el-select
        v-model="selectedoccupation"
        :placeholder="$t('registmessage.selectoccupation')"
        style="display: block"
      >
        <el-option
          v-for="item in occupation"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="1"
      ><div class="mx-2 mt-2" style="float: left; color: red">*</div></el-col
    >
    <el-col :span="9"></el-col>
  </el-row>
  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="occupationempty" class="sfont">Occupation empty</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>

  <!-- 用途 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="selectedusage != ''" class="utitle">
        {{ $t("registmessage.selectusage") }}
      </p></el-col
    >

    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" :class="[selectedusage == '' ? 'mt-3' : 'mt-0']">
    <el-col :span="9">
      <el-select
        v-model="selectedusage"
        :placeholder="$t('registmessage.selectusage')"
        style="display: block"
      >
        <el-option
          v-for="item in usage"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="1"
      ><div class="mx-2 mt-2" style="float: left; color: red">*</div></el-col
    >
    <el-col :span="9"></el-col>
  </el-row>
  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="usageempty" class="sfont">Usage empty</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>
  <!-- 国别 -->
  <el-row justify="center" class="mt-4">
    <el-col :span="9"
      ><p v-if="selectedcountry != ''" class="utitle">
        {{ $t("registmessage.selectcountry") }}
      </p></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" :class="[selectedcountry == '' ? 'mt-3' : 'mt-0']">
    <el-col :span="9">
      <el-select
        v-model="selectedcountry"
        :placeholder="$t('registmessage.selectcountry')"
        style="display: block"
      >
        <el-option
          v-for="item in country"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="1"
      ><div class="mx-2 mt-2" style="float: left; color: red">*</div></el-col
    >
    <el-col :span="9"></el-col>
  </el-row>
  <el-row justify="center">
    <el-col :span="9"
      ><div v-if="countryempty" class="sfont">Country empty</div></el-col
    >
    <el-col :span="10"></el-col>
  </el-row>
  <el-row justify="center" class="mt-5">
    <el-col :span="10">
      {{ $t("registmessage.shouquan") }}
    </el-col>
  </el-row>

  <el-row justify="end" class="mt-2">
    <el-col :span="2"></el-col>
    <el-col :span="5">
      <el-button class="mb-5" type="primary" @click="onregister">{{
        $t("registmessage.register")
      }}</el-button>
    </el-col>
  </el-row>
</template>

<script>
import { ref, reactive, toRefs, computed, onMounted } from "vue";
import { ElMessageBox } from "element-plus";
import { checkusername, singup } from "../../js/userhandler";
import { des } from "../../js/des";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default {
  setup() {
    //#region 变量
    const router = useRouter();
    const { t } = useI18n(); //使用i18n对象
    const firstname = ref("");
    const lastname = ref("");
    const myusername = ref("");
    const passwd = ref("");
    const company = ref("");
    const confirmpasswd = ref("");
    const email = ref("");
    const cemail = ref("");
    const selectedcountry = ref("");
    const selectedusage = ref("");
    const selectededucation = ref("");
    const selectedoccupation = ref("");
    const selecteddomain = ref("");
    const advisedusername = ref(""); //建议用户名
    const state = reactive({
      invalidemail: false,
      sameemail: true,
      invalidpasswd: false,
      samepasswd: true,
      submitted: false,
      usernamestatus: 2,
    });
    let count = 0;
    const education = [
      {
        value: "Student in School",
        label: "Student in School",
      },
      {
        value: "Undergraduate",
        label: "Undergraduate",
      },
      {
        value: "Master",
        label: "Master",
      },
      {
        value: "Doctor",
        label: "Doctor",
      },
      {
        value: "Post-doctor",
        label: "Post-doctor",
      },
      {
        value: "Others",
        label: "Others",
      },
    ];
    const occupation = [
      {
        value: "IT / Computer professionals",
        label: "IT / Computer professionals",
      },
      {
        value: "University professors and teachers ",
        label: "University professors and teachers ",
      },
      {
        value: "Engineers ",
        label: "Engineers ",
      },
      {
        value: "Scientists",
        label: "Scientists",
      },

      {
        value: "Market research analysts",
        label: "Market research analysts",
      },
      {
        value: "Teachers in elementary or secondary schools, colleges",
        label: "Teachers in elementary or secondary schools, colleges",
      },
      {
        value: "Students",
        label: "Students",
      },
      {
        value: "Others",
        label: "Others",
      },
    ];
    const domain = [
      { value: "Agriculture Science", label: "Agriculture Science" },
      { value: "Forest Science", label: "Forest Science" },
      { value: "Water resources", label: "Water resources" },
      { value: "Disaster management", label: "Disaster management" },
      { value: "Biodiversity", label: "Biodiversity" },
      {
        value: "Geographic Information System（GIS）",
        label: "Geographic Information System（GIS）",
      },
      { value: "Geology", label: "Geology" },
      { value: "Atmospheric Science", label: "Atmospheric Science" },
      { value: "Marine Science", label: "Marine Science" },
      { value: "Computer Science", label: "Computer Science" },
      { value: "Others", label: "Others" },
    ];
    const usage = [
      {
        value: "Research",
        label: "Research",
      },
      {
        value: "Commercial",
        label: "Commercial",
      },
      {
        value: "Education",
        label: "Education",
      },
      {
        value: "Other",
        label: "Other",
      },
    ];
    const country = [
      "Afghanistan",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Arctic Ocean",
      "Argentina",
      "Armenia",
      "Aruba",
      "Ashmore and Cartier Islands",
      "Atlantic Ocean",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Baltic Sea",
      "Baker Island",
      "Bangladesh",
      "Barbados",
      "Bassas da India",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Borneo",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cape Verde",
      "Cayman Islands",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Clipperton Island",
      "Cocos Islands",
      "Colombia",
      "Comoros",
      "Cook Islands",
      "Coral Sea Islands",
      "Costa Rica",
      "Cote d Ivoire",
      "Croatia",
      "Cuba",
      "Curacao",
      "Cyprus",
      "Czech Republic",
      "Democratic Republic of the Congo",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Europa Island",
      "Falkland Islands (Islas Malvinas)",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern and Antarctic Lands",
      "Gabon",
      "Gambia",
      "Gaza Strip",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Glorioso Islands",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and McDonald Islands",
      "Honduras",
      "Hong Kong",
      "Howland Island",
      "Hungary",
      "Iceland",
      "India",
      "Indian Ocean",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Jan Mayen",
      "Japan",
      "Jarvis Island",
      "Jersey",
      "Johnston Atoll",
      "Jordan",
      "Juan de Nova Island",
      "Kazakhstan",
      "Kenya",
      "Kerguelen Archipelago",
      "Kingman Reef",
      "Kiribati",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Line Islands",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mediterranean Sea",
      "Mexico",
      "Micronesia, Federated States of",
      "Midway Islands",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Navassa Island",
      "Nepal",
      "Netherlands",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "North Korea",
      "North Macedonia",
      "North Sea",
      "Northern Mariana Islands",
      "Norway",
      "Oman",
      "Pacific Ocean",
      "Pakistan",
      "Palau",
      "Palmyra Atoll",
      "Panama",
      "Papua New Guinea",
      "Paracel Islands",
      "Paraguay",
      "Peru",
      "Philippines",
      "Pitcairn Islands",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Republic of the Congo",
      "Reunion",
      "Romania",
      "Ross Sea",
      "Russia",
      "Rwanda",
      "Saint Barthelemy",
      "Saint Helena",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Martin",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Sint Maarten",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "South Korea",
      "South Sudan",
      "Southern Ocean",
      "Spain",
      "Spratly Islands",
      "Sri Lanka",
      "State of Palestine",
      "Sudan",
      "Suriname",
      "Svalbard",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan,China",
      "Tajikistan",
      "Tanzania",
      "Tasman Sea",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tromelin Island",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "Uruguay",
      "USA",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Viet Nam",
      "Virgin Islands",
      "Wake Island",
      "Wallis and Futuna",
      "West Bank",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ];

    //#endregion
    onMounted(() => {
      if (t == {}) console.log("");
    });
    //#region 状态计算
    const passwdvalidation = computed(() => {
      if (passwd.value.length == 0 && !state.submitted) return true;

      if (passwd.value.length < 8) return false;
      else return true;
    });
    const passwderrmess = computed(() => {
      if (passwd.value.length == 0) return "Empty password";
      else return "Password too short. Minimun 8 characters";
    });
    const countryempty = computed(() => {
      if (selectedcountry.value == "" && state.submitted) return true;
      else return false;
    });
    const usageempty = computed(() => {
      if (selectedusage.value == "" && state.submitted) return true;
      else return false;
    });
    const domainempty = computed(() => {
      if (selecteddomain.value == "" && state.submitted) return true;
      else return false;
    });
    const occupationempty = computed(() => {
      if (selectedoccupation.value == "" && state.submitted) return true;
      else return false;
    });
    const educationempty = computed(() => {
      if (selectededucation.value == "" && state.submitted) return true;
      else return false;
    });
    const lastnameempty = computed(() => {
      if (lastname.value == "" && state.submitted) return true;
      else return false;
    });
    const firstnameempty = computed(() => {
      if (firstname.value == "" && state.submitted) return true;
      else return false;
    });
    const usernameempty = computed(() => {
      if (myusername.value == "" && state.submitted) return true;
      else return false;
    });
    //#endregion

    const onconfirmemail = () => {
      if (email.value != cemail.value) state.sameemail = false;
      else state.sameemail = true;
    };
    //密码是否长度符合要求
    const oncheckpasswd = () => {
      count = 1;
      console.log(count);
      if (passwd.value.length < 8) state.invalidpasswd = true;
      else state.invalidpasswd = false;
    };

    //密码是否一致
    const onconfirmpasswd = () => {
      if (passwd.value != confirmpasswd.value) state.samepasswd = false;
      else state.samepasswd = true;
    };

    const oncheckusername = () => {
      // 检查用户名是否已经存在
      if (myusername.value != "") {
        checkusername(myusername.value).then((res) => {
          if (res.status === 200) {
            if (res.data.usernamestatus != undefined) {
              if (res.data.usernamestatus == "1") {
                state.usernamestatus = 1;
              } else {
                state.usernamestatus = 0;
                advisedusername.value = res.data.advisedusername;
              }
            }
          }
        });
      }
    };
    //点击注册
    const onregister = () => {
      state.submitted = true;
      onconfirmemail();
      onconfirmpasswd();
      ValidateEmail();

      if (
        firstname.value == "" ||
        lastname.value == "" ||
        myusername.value == "" ||
        state.invalidemail ||
        state.invalidpasswd ||
        !state.sameemail ||
        !state.samepasswd ||
        usageempty.value ||
        domainempty.value ||
        educationempty.value ||
        occupationempty.value ||
        countryempty.value
      ) {
        console.log("输入不完全");

        passwd.value = "";
        confirmpasswd.value = "";
        return;
      } else {
        let encripypasswd = des("tuiguang", passwd.value, 1, 0);
        singup(
          myusername.value,
          encripypasswd,
          firstname.value,
          lastname.value,
          selecteddomain.value,
          selectedusage.value,
          selectedcountry.value,
          email.value,
          selectededucation.value,
          selectedoccupation.value
        ).then((res) => {
          if (res.status == "200") {
            if (res.data.status === "1") {
              ElMessageBox.alert(
                "You have successfully registered. The system administrator will process your application and send you a confirmation email.",
                {
                  confirmButtonText: "OK",
                }
              );
              router.push("querymap");
            } else {
              ElMessageBox.alert("Username already taken", {
                confirmButtonText: "OK",
                type: "warning",
              });
            }
          }
        });
      }
    };
    function ValidateEmail() {
      var mailformat =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (email.value.match(mailformat)) {
        state.invalidemail = false;
      } else {
        state.invalidemail = true;
      }
    }

    return {
      firstname,
      domain,
      education,
      occupation,
      usage,
      myusername,
      lastname,
      country,
      confirmpasswd,
      passwd,
      email,
      cemail,
      company,
      advisedusername,
      ...toRefs(state),
      onconfirmemail,
      onconfirmpasswd,
      oncheckpasswd,
      ValidateEmail,
      onregister,
      usernameempty,
      firstnameempty,
      lastnameempty,
      domainempty,
      occupationempty,
      educationempty,
      usageempty,
      countryempty,
      passwdvalidation,
      passwderrmess,
      selectedcountry,
      selecteddomain,
      selectedoccupation,
      selectededucation,
      selectedusage,
      oncheckusername,
    };
  },
};
</script>

<style scoped>
.sfont {
  color: rgb(255, 102, 0);
  font-size: 0.65em;
}
.utitle {
  float: left;
  color: gray;
  font-size: 0.65em;

  margin-bottom: 0.1em;
}
</style>
